import { CORE_LINT_RULES } from './rules';
import { CORE_RUNTIME_LINT_RULES } from './runtimeRules';

// Parts of the contract that can't be lint rules (there's no source violation to detect), so
// getCompositionAuthoringGuidance() folds them in alongside the rule-derived guidance.
export const HTML_COMPOSITION_CONTRACT: string[] = [
    'GSAP is provided as a global (a pinned build is injected by the host). Use the `gsap` global directly; do NOT add a `<script src>` to load GSAP.',
    "The video's palette is injected as `--l5-color-0` … `--l5-color-N` CSS variables on `:root`. Reference them (e.g. `color: var(--l5-color-0, #101820)`) so the design recolors with the video's theme; always include a literal fallback.",
    'Embed any custom fonts inline as base64 `@font-face` data-URIs — the rasterizer cannot fetch externally-linked or page fonts. System fonts may be used directly.',
];

// Derived from the lint rules' own `guidance` so an authoring prompt can't drift from what the
// linter enforces. Returns a markdown bullet list, deduped (two rules share the editable-id line).
export function getCompositionAuthoringGuidance(): string {
    const ruleGuidance = [...CORE_LINT_RULES, ...CORE_RUNTIME_LINT_RULES]
        .map((rule) => rule.guidance)
        .filter((guidance): guidance is string => Boolean(guidance));
    const uniqueItems = [...new Set([...HTML_COMPOSITION_CONTRACT, ...ruleGuidance])];
    return uniqueItems.map((item) => `- ${item}`).join('\n');
}
